import { render, staticRenderFns } from "./ProfileAbout.vue?vue&type=template&id=d7f8ae7a&scoped=true&"
import script from "./ProfileAbout.vue?vue&type=script&lang=js&"
export * from "./ProfileAbout.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAbout.vue?vue&type=style&index=0&id=d7f8ae7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f8ae7a",
  null
  
)

export default component.exports